import React from 'react';
import styles from './UIGamePlayerInformation.module.scss';
import clsx from 'clsx';
import { UIGamePlayerInformationUser } from './UIGamePlayerInformationUser/index.ts';
import { UIGamePlayerInformationCards } from './UIGamePlayerInformationCards/index.ts';
import { UIGamePlayerInformationProgress } from './UIGamePlayerInformationProgress/index.ts';
import { ModeSettingEnum } from '@colonist/types';
export const UIGamePlayerInformation = ({ gameMode, isActive = false, playerValidator, isCurrentUser, translationContext, amountOfResourceCards, cardDiscardLimit, knightDevelopmentCardsUsedCount, hasLargestArmy, longestRoadCount, hasLongestRoad, developmentCards, progressCards, victoryPointsToWin, knightStrength, hasHighestKnightStrength, cityImprovementState, isTakingAction = false, hasMerchant = false, hasSpecialBuildPhaseFlag = false, hasRobber = false, className })=>{
    const isCityAndKnightMode = [
        ModeSettingEnum.CitiesAndKnights4P,
        ModeSettingEnum.CitiesAndKnights56P,
        ModeSettingEnum.CitiesAndKnightsSeafarers4P,
        ModeSettingEnum.CitiesAndKnightsSeafarers56P
    ].includes(gameMode);
    const amountOfDevelopmentCards = isCityAndKnightMode ? progressCards.cards.length : developmentCards.cards.length;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className, {
            [styles.active]: isActive,
            [styles.currentUser]: isCurrentUser
        })
    }, isCurrentUser && /*#__PURE__*/ React.createElement("div", {
        className: styles.usernameLarge
    }, playerValidator.userState.username), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.informationWrapper, {
            [styles.active]: isActive
        })
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInformationUser, {
        hasMerchant: hasMerchant,
        hasSpecialBuildPhaseFlag: hasSpecialBuildPhaseFlag,
        isCurrentUser: isCurrentUser,
        isTakingAction: isTakingAction,
        playerValidator: playerValidator,
        victoryPointsToWin: victoryPointsToWin,
        hasRobber: hasRobber
    }), /*#__PURE__*/ React.createElement(UIGamePlayerInformationCards, {
        modeSetting: gameMode,
        amountOfDevelopmentCards: amountOfDevelopmentCards,
        amountOfResourceCards: amountOfResourceCards,
        cardDiscardLimit: cardDiscardLimit,
        isCityAndKnightMode: isCityAndKnightMode,
        isCurrentUser: isCurrentUser,
        progressCards: progressCards,
        translationContext: translationContext
    }), /*#__PURE__*/ React.createElement(UIGamePlayerInformationProgress, {
        cityImprovementState: cityImprovementState,
        hasHighestKnightStrength: hasHighestKnightStrength,
        hasLargestArmy: hasLargestArmy,
        hasLongestRoad: hasLongestRoad,
        isCityAndKnightMode: isCityAndKnightMode,
        isCurrentUser: isCurrentUser,
        knightDevelopmentCardsUsedCount: knightDevelopmentCardsUsedCount,
        knightStrength: knightStrength,
        longestRoadCount: longestRoadCount,
        translationKeyContext: translationContext,
        playerValidator: playerValidator
    })));
};
